import { Pressable, View } from 'dripsy';
import * as React from 'react';
export const BtnIcon = ({ isDisabled, children, ...props }) => (React.createElement(Pressable, { sx: {
        position: 'absolute',
        right: '$0',
        top: '$0',
        bottom: '$0',
        width: '$10',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: '$1',
        borderWidth: 0,
        ...(isDisabled && { cursor: 'not-allowed' }),
    }, disabled: isDisabled, ...props },
    React.createElement(View, { sx: { height: 24, width: 24 } }, React.cloneElement(children, {
        color: isDisabled ? 'secondaryBackgroundActive' : 'text',
    }))));
BtnIcon.displayName = 'BtnIcon';
//# sourceMappingURL=BtnIcon.js.map